import type { FunctionComponent } from "react";
import { Button, Loader } from "@kanda-libs/ks-design-library";
import useDownloadEpvsButtonProps from "components/job/JobLayout/JobActions/DownloadEpvsButton/useDownloadEpvsButtonProps";

export interface DownloadEpvsButtonProps {}

export const DownloadEpvsButton: FunctionComponent<
  DownloadEpvsButtonProps
> = () => {
  const { onClick, isSubmitting, isSolar, isLoading } =
    useDownloadEpvsButtonProps();

  if (!isSolar) {
    return <></>;
  }

  return (
    <>
      <Button.Text
        id="staff-download-epvs-calculations"
        onClick={onClick}
        label="Download EPVS calculation"
        size={40}
        className="ml-4"
        disabled={isSubmitting}
        isLoading={isLoading}
      />
      <Loader isLoading={isSubmitting} />
    </>
  );
};

export default DownloadEpvsButton;
